import React, { useEffect } from "react";
import SelectValue from "../Selector/SelectValue";
import { DatePicker, Table, Tooltip } from "antd";
import { useDispatch } from "react-redux";
import { getReportSurveyByCard } from "../../../services/slice/SurveySlice";
import { useSelector } from "react-redux";
import { surveySelector } from "../../../services/selector/index.";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import PiceChart from "../Chart/PiceChart";
import { useMemo } from "react";
import { useState } from "react";
import InputSearchBox from "../Input/InputSearchBox";
import BaseButton from "../Button/BaseButton";
import "../../../assets/style/pageStyle/surverManager.scss";
import TranslateText from "../TranslateText";
import { IconDetail, IconNext, IconPre } from "../../../assets/icon";
import ModalDetailSurveyByCard from "../Modal/getDetail/ModalDetailSurveyByCard";

const TabPersonalDetails = ({ config }) => {
  const dispatch = useDispatch();
  const surveyState = useSelector(surveySelector);
  const { dataDetailByCard } = surveyState;
  const [page, setPage] = useState(0);
  const formatDate = "DD/MM/YYYY";
  const [questionSelect, setQuestionSelect] = useState("");
  const { total } = dataDetailByCard;
  const [openModalDetail, setOpenModalDetail] = useState(false);
  const [bodyRequest, setBodyRequest] = useState({
    id: config.id,
    card: "",
    typeSurvey: 1,
    timeStart: "2023-10-02 10:28:53",
    timeEnd: "2023-10-02 10:28:53",
    option: {
      limit: 10,
      offset: 1,
      order: "desc",
    },
  });
  const [payloadConfig, setPayloadConfig] = useState({
    id: config.id,
    card: "",
    time: "",
  });

  useEffect(() => {
    dispatch(getReportSurveyByCard(bodyRequest));
  }, [bodyRequest, dispatch]);
  //   useEffect(() => {
  //     dispatch(
  //       getReportSurveyOverView({
  //         id: Number(config?.id),
  //         typeSurvey: Number(config?.typeSurvey),
  //         typeTime: Number(config?.typeTime),
  //         timeStart: config?.timeStart,
  //         timeEnd: config?.timeEnd,
  //       })
  //     );
  //   }, [config]);
  const options = useMemo(() => {
    const result = [];
    // listQuestionById?.map((item, index) => {
    //   result.push({
    //     value: item,
    //     label: `Câu ${index + 1}: ${item}`,
    //   });
    // });
    // setQuestionSelect(result[0]?.value);
    return result;
  }, []);
  const dataSource = useMemo(() => {
    const result = dataDetailByCard?.data?.map((item, index) => {
      return {
        ...item,
        // timeAnswer: formatDate(item?.timeAnswer),
        STT:
          dataDetailByCard.total > 10 && page >= 2
            ? (page - 1) * 10 + index + 1
            : index + 1,
        key: item.id,
      };
    });
    return result;
  }, [dataDetailByCard]);
  const columns = [
    {
      title: "STT",
      dataIndex: "STT",
      key: "STT",
      className: "centerCell",
      width: 70,
    },

    {
      title: <TranslateText text="Mã khách hàng" />,
      dataIndex: "card",
      key: "card",
      className: "title  centerCell",
      width: 300,
      ellipsis: {
        showTitle: false,
      },
      render: (value) => (
        <Tooltip placement="topLeft" title={value}>
          {value}
        </Tooltip>
      ),
    },
    {
      title: <TranslateText text="Thời gian phản hồi" />,
      dataIndex: "time",
      key: "time",
      className: "title  centerCell",
      width: "55%",
      ellipsis: {
        showTitle: false,
      },
      render: (value) => (
        <Tooltip placement="topLeft" title={value}>
          {value}
        </Tooltip>
      ),
    },
    {
      title: <TranslateText text="Chức năng" />,
      key: "action",
      dataIndex: "action",
      className: "centerCell m10",
      render: (text, record) => {
        return (
          <div
            className="centerCell flex justify-center w-full "
            style={{ minWidth: "120px" }}
          >
            <span
              className="pointer iconTbl "
              onClick={() => {
                setPayloadConfig({
                  ...payloadConfig,
                  card: record.card,
                  time: record.time,
                });
                setOpenModalDetail(true);
              }}
            >
              <Tooltip title="Xem thông tin">
                <IconDetail />
              </Tooltip>
            </span>
          </div>
        );
      },
    },
  ];
  return (
    <>
      {openModalDetail ? (
        <ModalDetailSurveyByCard
          open={openModalDetail}
          payloadConfig={payloadConfig}
          setOpen={setOpenModalDetail}
        />
      ) : null}
      <div className="wrapperQuestionSurvey">
        <div className="headerQuestionSurvey">
          <div className="searchBox">
            <span style={{ marginRight: "1.4rem", fontSize: "1.8rem" }}>
              Mã khách hàng
            </span>
            <InputSearchBox
              setText={(value) =>
                setBodyRequest({ ...bodyRequest, card: value })
              }
              width={"320px"}
              placeholder={"Nhập mã khách hàng để tra cứu"}
              optionsValue={options}
            />
          </div>
          <BaseButton
            typeBtn={"btnOrange"}
            className={"bottom-0"}
            content={"Xuất excel"}
          />
        </div>

        <Table
          // rowClassName={rowClassName}
          //   loading={tableLoading}
          className="wrapperTblSurvey"
          style={{ width: "100%", marginTop: "2.6rem" }}
          columns={columns}
          dataSource={dataSource}
          pagination={
            total > 10
              ? {
                  onChange: (value) => {
                    setPage(value);
                  },
                  total,
                  pageSize: 10,
                  // current: configStatistics.option.offset,
                  prevIcon: <IconPre />,
                  nextIcon: <IconNext />,
                  showSizeChanger: false,
                }
              : false
          }
        />
      </div>
    </>
  );
};

export default TabPersonalDetails;
